module.exports = __webpack_public_path__ + "static/media/close.9d1c07b4.svg";